<div class="video-preview-widget">
  @if (thumbnailUrl()) {
    <a [href]="url()" class="video-preview-widget__thumbnail-container" target="_blank" rel="noopener noreferrer">
      <img [src]="thumbnailUrl()" [alt]="title()" class="video-preview-widget__thumbnail" />

      <outlaw-icon name="playVideo" size="48px" class="video-preview-widget__play-icon"></outlaw-icon>
    </a>
  }

  @if (title()) {
    <h6 class="video-preview-widget__title">{{ title() }}</h6>
  }
</div>
